module.exports = __webpack_public_path__ + "img/zhaoshang_tianxie@2x.9bcfab62.png";